import type { AutoFixProvider } from '@/lib/ai-review-settings/schema';

const AUTO_FIX_PROVIDER_ACTION_LABELS: Record<AutoFixProvider, string> = {
  cubic: 'Fix with cubic',
  cursor_cloud_agent: 'Fix with Cursor',
};

export function resolveAutoFixProviderActionLabel(provider: AutoFixProvider): string {
  return AUTO_FIX_PROVIDER_ACTION_LABELS[provider] ?? AUTO_FIX_PROVIDER_ACTION_LABELS.cubic;
}
